import LocationGraphics from './LocationGraphics';

let path = '././assets/images/';

let assetArray = [{
        id: 'wharenuiInterior',
        path: path + 'wharenui-interior.svg'
    },
    {
        id: 'tukutuku',
        path: path + 'tukutuku.svg'
    }, {
        id: 'tukutukuPanel',
        path: path + 'tukutuku-panel.svg'
    }, {
        id: 'pou',
        path: path + 'pou.svg'
    }, {
        id: 'pouPanel',
        path: path + 'pou-panel.svg'
    }, {
        id: 'heke',
        path: path + 'heke.svg'
    }, {
        id: 'hekePanel',
        path: path + 'heke-panel.svg'
    }, {
        id: 'hekePanel2',
        path: path + 'heke-panel2.svg'
    }, {
        id: 'check',
        path: path + 'check.svg'
    }, {
        id: 'cross',
        path: path + 'x.svg'
    }, {
        id: 'wharenui',
        path: '././assets/sounds/wharenui.mp3'
    }
];

export default class WharenuiGraphics extends LocationGraphics {
    constructor() {
        super('wharenuiGraphics');
        this.assetArray = assetArray;
    }


    addGraphics(container) {

        this.parent.cameras.main.setBackgroundColor('rgba(0, 0, 0, 1)');
        let tm = 'tuktuku';
        let te = 'ornamental lattice work/\nwoven panel';
        let pm = 'pou';
        let pe = 'carving';

        container.add(this.utils.addImage(this.parent, {
            id: 'wharenuiInterior',
            x: -18,
            y: 0
        }));

        container.add(this.utils.addImage(this.parent, {
            id: 'tukutukuPanel',
            x: 675,
            y: 195,
            maori: tm,
            english: te,
            location: 'tukutuku',
            swapImage: 'tukutuku'
        }));

        container.add(this.utils.addImage(this.parent, {
            id: 'pouPanel',
            x: 117,
            y: 199,
            maori: pm,
            english: pe,
            location: 'aoraki',
            swapImage: 'pou'
        }));

        container.add(this.utils.addImage(this.parent, {
            id: 'hekePanel',
            x: -18,
            y: -30,
            maori: 'heke',
            english: 'rafter',
            location: 'heke',
            swapImage: 'heke',
            hit: [
                [0, 297],
                [317, 0],
                [362, 6],
                [26, 315]
            ]
        }));
        container.add(this.utils.addImage(this.parent, {
            id: 'hekePanel2',
            x: 480,
            y: 0,

            maori: 'heke',
            english: 'rafter',
            location: 'heke',
            swapImage: 'heke',
            hit: [
                [0, 0],
                [58, 0],
                [326, 260],
                [275, 260]
            ]
        }));

        //****TUKUTUKU 1 */
        container.add(this.utils.addImage(this.parent, {
            x: 64,
            y: 226,
            maori: tm,
            english: te,
            hit: [
                [1, 260],
                [0, 12],
                [55, 0],
                [59, 219]
            ]
        }));
        //****TUKUTUKU 2 */
        container.add(this.utils.addImage(this.parent, {
            x: 175,
            y: 161,
            maori: tm,
            english: te,
            hit: [
                [4, 245],
                [0, 51],
                [68, 0],
                [76, 244]
            ]
        }));
        //****TUKUTUKU 3 */
        container.add(this.utils.addImage(this.parent, {
            x: 313,
            y: 57,
            maori: tm,
            english: te,
            hit: [
                [5, 347],
                [0, 50],
                [69, 0],
                [69, 312],
                [48, 346]
            ]
        }));
        //****TUKUTUKU 4 */
        container.add(this.utils.addImage(this.parent, {
            x: 412,
            y: 51,
            maori: tm,
            english: te,
            hit: [
                [22, 357],
                [0, 264],
                [0, 0],
                [72, 56],
                [74, 353]
            ]
        }));
        //****TUKUTUKU 5 */
        container.add(this.utils.addImage(this.parent, {
            x: 555,
            y: 160,
            maori: tm,
            english: te,
            hit: [
                [0, 242],
                [0, 0],
                [67, 51],
                [65, 242]
            ]
        }));
        //****POU 1 */
        container.add(this.utils.addImage(this.parent, {
            x: -15,
            y: 240,
            maori: pm,
            english: pe,
            hit: [
                [0, 304],
                [3, 21],
                [76, 0],
                [81, 249]
            ]
        }));
        //****POU 2 */
        container.add(this.utils.addImage(this.parent, {
            x: 620,
            y: 212,
            maori: pm,
            english: pe,
            hit: [
                [0, 189],
                [3, 0],
                [53, 11],
                [53, 237]
            ]
        }));
        //****POU 3 */
        container.add(this.utils.addImage(this.parent, {
            x: 738,
            y: 246,
            maori: pm,
            english: pe,
            hit: [
                [0, 256],
                [5, 0],
                [70, 18],
                [71, 303]
            ]
        }));

        //*** SKY FATHER */
        container.add(this.utils.addImage(this.parent, {
            x: 243,
            y: 107,
            maori: 'pou - Ranginui',
            english: 'carving - Sky Father',
            hit: [
                [6, 296],
                [0, 52],
                [69, 0],
                [74, 296]
            ]
        }));
        //*** EARTH MOTHER */
        container.add(this.utils.addImage(this.parent, {
            x: 486,
            y: 106,
            maori: 'pou - Papatūānuku',
            english: 'carving - Earth Mother',
            hit: [
                [2, 298],
                [0, 0],
                [69, 52],
                [67, 297]
            ]
        }));

        /*** MAT */
        container.add(this.utils.addImage(this.parent, {
            x: -12,
            y: 404,
            maori: 'whāriki',
            english: 'floor mat',
            hit: [
                [0, 139],
                [192, 2],
                [633, 0],
                [799, 134],

            ]
        }));

        /***RIDGE POLE */
        container.add(this.utils.addImage(this.parent, {
            x: 360,
            y: 0,
            maori: 'poutokomanawa',
            english: 'central ridgepole of a wharenui',
            hit: [
                [0, 529],
                [0, 403],
                [22, 372],
                [21, 0],
                [53, 0],
                [53, 319],
                [75, 411],
                [80, 533]
            ]
        }));


        super.addGraphics();


    }
}